import { useEffect } from "react";
import { useForm } from "react-hook-form";
import TagManager from "react-gtm-module";
import { yupResolver } from "@hookform/resolvers/yup";
import Email from "../../components/Email";
import { Checkbox, Error } from "../../styles/global";
import Button from "../../components/Button";
import Options from "../../components/Options";
import { schema } from "./validations";
import HiddenInputs from "../../components/HiddenInputs";

import { Container, Title, Form } from "./style";

const Experience = ({ email, setEmail }) => {
  const url = "https://kenzie39049.activehosted.com/proc.php";

  const { errors, register, watch, setError, clearErrors } = useForm({
    resolver: yupResolver(schema),
  });

  useEffect(() => {
    TagManager.dataLayer({
      dataLayer: { event: "lead-inscricao" },
    });
  });

  const alternatives = watch(["field[142]"])["field[142]"];
  const hadExperience = watch(["field[145]"])["field[145]"];
  const programmingLevel = watch(["field[146]"])["field[146]"];
  const muchTime = watch(["field[39]"])["field[39]"];
  const afterFiveYears = watch(["field[40]"])["field[40]"];

  const validateEmail = /^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/g;

  const submitData = (e) => {
    if (
      alternatives === null ||
      hadExperience === null ||
      programmingLevel === null ||
      muchTime === null ||
      afterFiveYears === null ||
      email === "" ||
      !validateEmail.test(email)
    ) {
      e.preventDefault();

      if (validateEmail.test(email) === false) {
        setError("email", {
          message: "O e-mail deve ser formatado corretamente",
        });
      }

      if (email === "") {
        setError("email", { message: "Preencha esse campo obrigatório." });
      }

      if (alternatives === null) {
        setError("alternativesError", {
          message: "Preencha este campo obrigatório.",
        });
      }

      if (hadExperience === null) {
        setError("hadExperienceError", {
          message: "Preencha este campo obrigatório.",
        });
      }

      if (programmingLevel === null) {
        setError("programmingLevelError", {
          message: "Preencha este campo obrigatório.",
        });
      }

      if (muchTime === null) {
        setError("howMuchTimeAreLooking", {
          message: "Preencha este campo obrigatório.",
        });
      }

      if (afterFiveYears === null) {
        setError("objective", { message: "Preencha este campo obrigatório." });
      }

      return false;
    }

    localStorage.setItem("email", email);
    return true;
  };

  useEffect(() => {
    if (alternatives !== null) {
      clearErrors("alternativesError");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [alternatives]);

  useEffect(() => {
    if (hadExperience !== null) {
      clearErrors("hadExperienceError");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hadExperience]);

  useEffect(() => {
    if (programmingLevel !== null) {
      clearErrors("programmingLevelError");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [programmingLevel]);

  useEffect(() => {
    if (muchTime !== null) {
      clearErrors("howMuchTimeAreLooking");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [muchTime]);

  useEffect(() => {
    if (afterFiveYears !== null) {
      clearErrors("objective");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [afterFiveYears]);

  useEffect(() => {
    if (email !== "") {
      clearErrors("email");
    }

    if (validateEmail.test(email)) {
      clearErrors("email");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [email]);

  return (
    <>
      <Container id="main">
        <Form onSubmit={submitData} method="POST" action={url} validate>
          <HiddenInputs formId={158} />

          <Email
            inputRef={register}
            name="email"
            error={errors.email?.message}
            value={email}
            onChange={setEmail}
          />
          <Title>Porque busca a programação?</Title>

          <Options>
            <legend>Qual destas alternativas te representa melhor?</legend>
            <Checkbox>
              <label>
                <input
                  type="radio"
                  ref={register}
                  name="field[142]"
                  value="Me formei ou quase me formei na graduação, mas não me vejo exercendo minha profissão"
                />
                Me formei ou quase me formei na graduação/curso técnico, mas não
                me vejo exercendo a área que estudei
              </label>
            </Checkbox>
            <Checkbox>
              <label>
                <input
                  type="radio"
                  ref={register}
                  name="field[142]"
                  value="Tinha uma profissão, mas quero mudar completamente de área"
                />
                Tinha uma profissão, mas quero mudar completamente de área
              </label>
            </Checkbox>

            <Checkbox>
              <label>
                <input
                  type="radio"
                  ref={register}
                  name="field[142]"
                  value="Outros"
                />
                Outros
              </label>
            </Checkbox>

            <Error>{errors.alternativesError?.message}</Error>
          </Options>

          <Options>
            <legend>Você já trabalhou na área de tecnologia?</legend>

            <Checkbox>
              <label>
                <input
                  type="radio"
                  ref={register}
                  name="field[145]"
                  value="Sim, na área de programação"
                />
                Sim, na área de programação
              </label>
            </Checkbox>
            <Checkbox>
              <label>
                <input
                  type="radio"
                  ref={register}
                  name="field[145]"
                  value="Sim, na área de infraestrutura"
                />
                Sim, na área de infraestrutura
              </label>
            </Checkbox>

            <Checkbox>
              <label>
                <input
                  type="radio"
                  ref={register}
                  name="field[145]"
                  value="Sim, na área de QA"
                />
                Sim, na área de QA
              </label>
            </Checkbox>
            <Checkbox>
              <label>
                <input
                  type="radio"
                  ref={register}
                  name="field[145]"
                  value="Sim, em outra área"
                />
                Sim, em outra área
              </label>
            </Checkbox>
            <Checkbox>
              <label>
                <input
                  type="radio"
                  ref={register}
                  name="field[145]"
                  value="Não"
                />
                Não
              </label>
            </Checkbox>

            <Error>{errors.hadExperienceError?.message}</Error>
          </Options>

          <Options>
            <legend>
              Qual o seu nível de conhecimento em programação? Tudo bem se não
              tiver experência.
            </legend>

            <Checkbox>
              <label>
                <input
                  type="radio"
                  ref={register}
                  name="field[146]"
                  value="Nunca vi vídeos nem escrevi nenhuma linha de código"
                />
                Nunca vi vídeos nem escrevi nenhuma linha de código
              </label>
            </Checkbox>
            <Checkbox>
              <label>
                <input
                  type="radio"
                  ref={register}
                  name="field[146]"
                  value="Já estudei/vi vídeos de programação, mas nunca escrevi uma linha de código"
                />
                Já estudei/vi vídeos de programação, mas nunca escrevi uma linha
                de código
              </label>
            </Checkbox>

            <Checkbox>
              <label>
                <input
                  type="radio"
                  ref={register}
                  name="field[146]"
                  value="Já estudei/vi vídeos de programação e codei um projeto"
                />
                Já estudei/vi vídeos de programação e codei um projeto
              </label>
            </Checkbox>
            <Checkbox>
              <label>
                <input
                  type="radio"
                  ref={register}
                  name="field[146]"
                  value="Já codei alguns projetos de maneira amadora"
                />
                Já codei alguns projetos de maneira amadora
              </label>
            </Checkbox>
            <Checkbox>
              <label>
                <input
                  type="radio"
                  ref={register}
                  name="field[146]"
                  value="Já trabalhei na área de programação"
                />
                Já trabalhei na área de programação
              </label>
            </Checkbox>

            <Error>{errors.programmingLevelError?.message}</Error>
          </Options>

          <Options>
            <legend>
              Há quanto tempo você está procurando um curso/escola de
              programação?
            </legend>

            <Checkbox>
              <label>
                <input
                  type="radio"
                  ref={register}
                  name="field[39]"
                  value="Há 2 semanas ou menos"
                />
                Há 2 semanas ou menos
              </label>
            </Checkbox>
            <Checkbox>
              <label>
                <input
                  type="radio"
                  ref={register}
                  name="field[39]"
                  value="Há 30 dias"
                />
                Há 30 dias
              </label>
            </Checkbox>
            <Checkbox>
              <label>
                <input
                  type="radio"
                  ref={register}
                  name="field[39]"
                  value="Há 60 dias"
                />
                Há 60 dias
              </label>
            </Checkbox>
            <Checkbox>
              <label>
                <input
                  type="radio"
                  ref={register}
                  name="field[39]"
                  value="Há 6 meses"
                />
                Há 6 meses
              </label>
            </Checkbox>
            <Checkbox>
              <label>
                <input
                  type="radio"
                  ref={register}
                  name="field[39]"
                  value="Há mais de 6 meses"
                />
                Há mais de 6 meses
              </label>
            </Checkbox>
            <Checkbox>
              <label>
                <input
                  type="radio"
                  ref={register}
                  name="field[39]"
                  value="Nunca procurei"
                />
                Nunca procurei
              </label>
            </Checkbox>

            <Error>{errors.howMuchTimeAreLooking?.message}</Error>
          </Options>

          <Options>
            <legend>
              Após formado na Kenzie, qual seu objetivo profissional (daqui 5
              anos)
            </legend>

            <Checkbox>
              <label>
                <input
                  type="radio"
                  ref={register}
                  name="field[40]"
                  value="Programador Full-Stack Sênior"
                />
                Programador Full-Stack Sênior
              </label>
            </Checkbox>
            <Checkbox>
              <label>
                <input
                  type="radio"
                  ref={register}
                  name="field[40]"
                  value="Especialista Front-End"
                />
                Especialista Front-End
              </label>
            </Checkbox>
            <Checkbox>
              <label>
                <input
                  type="radio"
                  ref={register}
                  name="field[40]"
                  value="Especialista Back-End"
                />
                Especialista Back-End
              </label>
            </Checkbox>
            <Checkbox>
              <label>
                <input
                  type="radio"
                  ref={register}
                  name="field[40]"
                  value="Freelancer"
                />
                Freelancer
              </label>
            </Checkbox>
            <Checkbox>
              <label>
                <input
                  type="radio"
                  ref={register}
                  name="field[40]"
                  value="Consultor em Tecnologia"
                />
                Consultor em Tecnologia
              </label>
            </Checkbox>
            <Checkbox>
              <label>
                <input
                  type="radio"
                  ref={register}
                  name="field[40]"
                  value="Empreendedor"
                />
                Empreendedor
              </label>
            </Checkbox>
            <Checkbox>
              <label>
                <input
                  type="radio"
                  ref={register}
                  name="field[40]"
                  value="Trabalhando em outra área"
                />
                Trabalhando em outra área
              </label>
            </Checkbox>

            <Error>{errors.objective?.message}</Error>
          </Options>

          {Object.keys(errors).length !== 0 && (
            <p>Preencha todos os campos obrigatórios</p>
          )}

          <Button>Continuar</Button>
        </Form>
      </Container>
    </>
  );
};

export default Experience;
